<template>
    <div
        v-if="ctaSections.length"
        class="event-detail__call-to-action"
        @click="onClick"
    >
        <FlexibleSections :sections="ctaSections" />
    </div>
</template>

<script setup lang="ts">
import type { CtaEntryFragment, FlexibleSectionsFragment } from '~/types/craft-schema';
import { useModalStore, MODAL_MAIN } from '~/stores/modal';

const props = defineProps<{
    ctas: CtaEntryFragment[];
}>();

const modalStore = useModalStore();

// Relabel CTA entries as Call to Action blocks so FlexibleSections recognizes them
const ctaSections = computed(() =>
    (props.ctas ?? []).map((cta) => ({
        ...cta,
        __typename: 'flexibleSections_callToAction_BlockType',
    })) as FlexibleSectionsFragment[]
);

// Close the modal when a link inside the CTA is clicked
const onClick = (event: MouseEvent) => {
    if ((event.target as HTMLElement).closest('a')) {
        modalStore.close(MODAL_MAIN);
    }
};
</script>